/**
 * Scelta multipla «Anche in copia a» (parte A): usata dalla modale di
 * trasferimento v3 e dal pannello rapido v4. Nessun canale proponibile e
 * nessuna copia esistente: non compare.
 */
import React from 'react';
import type { GroupLite } from '../../services/supportApi';

export const COPY_PICKER_LEGEND = 'Anche in copia a';

interface CopyGroupsPickerProps {
  options: GroupLite[];
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
  /** Nomi dei canali già in copia (restano: il trasferimento li aggiunge, non li toglie). */
  already?: string[];
}

const CopyGroupsPicker: React.FC<CopyGroupsPickerProps> = ({ options, value, onChange, disabled = false, already = [] }) => {
  if (options.length === 0 && already.length === 0) return null;
  const toggle = (id: string) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <fieldset className="s3-field" style={{ border: 0, padding: 0, margin: 0 }}>
      <legend className="s3-label">{COPY_PICKER_LEGEND}</legend>
      {already.length > 0 && <p className="s3-mod__note">Già in copia: {already.join(', ')}</p>}
      {options.map((g) => (
        <label key={g._id} className="s3-prop__val" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={value.includes(g._id)} disabled={disabled} onChange={() => toggle(g._id)} />
          {g.nome}
        </label>
      ))}
    </fieldset>
  );
};

export default CopyGroupsPicker;
